<template>
  <section class="section-wrapper white">
    <v-container class="home-how-it-works-container">
      <h2>How LendingWell Works</h2>

      <div class="item-group-wrapper">
        <div
          v-for="(item, index) in howItWorks"
          :key="index"
          class="item-group" >
          <div class="image-wrapper">
            <img :src="item.image" alt="how it works image" />
          </div>
          <h3>{{ item.title }}</h3>
          <p>{{ item.description }}</p>
        </div>
      </div>
    </v-container>
  </section>
</template>

<script>
import imageBulbs from '@/modules/home/assets/bulbs.png'
import imageComputer from '@/modules/home/assets/computer.png'
import imageEmail from '@/modules/home/assets/email.png'

export default {
  name: 'HomeHowItWorks',
  data: () => ({
    howItWorks: [
      {
        title: 'Tell us about yourself',
        description: 'Answer 10 simple questions regarding what you are looking for and the features you want.',
        image: imageComputer,
      },
      {
        title: 'Match with the right Lenders',
        description: 'We provide you with specific matches for your financing needs with verified reviews of each bank.',
        image: imageBulbs,
      },
      {
        title: 'Optimize',
        description: 'We will provide you with the ideal lenders so you get the best result.',
        image: imageEmail,
      },
    ],
  }),
}
</script>

<style lang="scss" scoped>
.home-how-it-works-container {
  .image-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;

    height: 170px;
  }

  h2, h3, p {
    text-align: center;
  }

  h2 {
    margin-bottom: 50px;
    text-align: center;

    @include lg {
      text-align: left;
    }
  }

  h3 {
    margin: 36px 0 8px 0;

    @include lgAndBelow {
      font-size: 16px;
      line-height: 18px;
    }
  }
}

.item-group-wrapper {
  display: grid;
  grid-template-columns: 270px;
  grid-template-rows: auto;
  justify-content: space-around;

  grid-row-gap: 40px;

  @include lg {
    grid-template-columns: repeat(3, 33%);
    grid-column-gap: 40px;
  }

  @include xl {
    grid-column-gap: 60px;
  }

  .item-group {
    display: flex;
    flex-direction: column;
    align-items: center;

    width: 100%;
  }

  img {
    max-width: 100%;
  }
}
</style>
